import { render } from "./MenuList.vue?vue&type=template&id=31862bf0"
import script from "./MenuList.vue?vue&type=script&lang=js"
export * from "./MenuList.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__